export default "__VITE_ASSET__ChQV4QKs__"